import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoadScript } from '@react-google-maps/api';

import 'bootstrap/dist/css/bootstrap.min.css';

import CartProvider from './CartContext';
import Nav from './components/Nav';
import Nav2 from './components/Nav2';
import Footer from './components/Footer';

import ProductList from './components/ProductList';
import ProductDetail from './components/ProductDetail';
import ProductDetailAdult from './components/ProductDetailAdult';
import Cancel from './components/pages/Cancel';
import Success from './components/pages/Success';
import ProductPage from './components/ProductPage';
import ContactUs from './components/ContactUs';
import AboutUs from './components/AboutUs';
import Policy from './components/Policy';
import Refund from './components/Refund';
import Terms from './components/Terms';
import Adult from './components/Adult';
import ImageTable from './components/ImageTable';
import SuccessPage from './components/SuccessPage';
import Login from './components/Login';
import AdultAccessories from './components/AdultAccessories';
import KidsAccessories from './components/KidsAccessories';
import KidProductDetail from './components/KidProductDetail';
import SanmarImages from './components/SanmarImages';
import ProductFTP from './components/ProductFTP';
import SubscribersList from './components/SubscriberList';
import TestShippo from './components/TestShippo';
import AdminOrders from './components/AdminOrders';
import OrdersPage from './components/OrdersPage';
import ProtectedRoute from './components/ProtectedRoute';
import Protected from './components/Protected';
import SignUp from './components/SignUp';
import ScreenPrinting from './components/ScreenPrinting';
import Embroidery from './components/Embroidery';
import LaserEtching from './components/LaserEtching';
import QuoteForm from './components/Quote';
import ComingSoon from './components/ComingSoon';
import KidBlanks from './components/KidBlanks';
import AdultsBlanks from './components/AdultsBlanks';
import SpinningWheelGame from './components/SpinningWheelGame';
import CustomStoreFromURL from './components/pages/CustomeStoreFromURL';
import ShippingGift from './components/ShippingGift';
import WhiteProductList from './components/WhiteProductList';
import WhiteProductDetail from './components/WhiteProductDetail';
import AdminUsers from './components/AdminUser';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const libraries = ['places']; // Required for Autocomplete

const App = () => {
  return (
    <CartProvider>
      <div className="app" style={{ paddingLeft: 15, paddingRight: 20, backgroundColor: 'white' }}>
        <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={libraries}>
          <BrowserRouter>
            {/* <Nav /> */}
            {/* <Nav2 /> */}
            <Routes>
              {/* <Route index element={<AboutUs />} /> */}
              <Route index element={<ComingSoon />} />
              <Route path="/kids-apparel-list" element={<ProductList />} />
              <Route path="/kids-apparel-list-white" element={<WhiteProductList />} />
              <Route path="/product/:style" element={<ProductDetail />} />
              <Route path="/white-product/:style" element={<WhiteProductDetail />} />
              <Route path="/kid-product/:style" element={<KidProductDetail />} />
              <Route path="/product-adult/:style" element={<ProductDetailAdult />} />
              <Route path="cancel" element={<Cancel />} />
              <Route path="success" element={<Success />} />
              <Route path="/managersuccess" element={<ProductPage />} />
              <Route path="/Contact-us" element={<ContactUs />} />
              <Route path="/our-policy" element={<Policy />} />
              <Route path="/refund-policy" element={<Refund />} />
              <Route path="/terms" element={<Terms />} />
              {/* <Route path="/kidsBlanks" element={<KidsProductsBlankList />} /> */}
              <Route path="/kidsBlanks" element={<KidBlanks />} />
              <Route path="/adultsBlanks" element={<AdultsBlanks />} />
              <Route path="/our-subscribers" element={<SubscribersList />} />
              <Route path="/adult-apparel" element={<Adult />} />
              <Route path="/accessories-adult" element={<AdultAccessories />} />
              <Route path="/kids-accessories-list" element={<KidsAccessories />} />
              <Route path="/login" element={<Login />} />
              <Route path="/sanmarImages" element={<SanmarImages />} />
              <Route path="/gallery" element={<ImageTable />} />
              <Route path="/ftp" element={<ProductFTP />} />
              <Route path="/claim" element={<ShippingGift />} />
              <Route path="/w&w-onlineStore" element={<CustomStoreFromURL />} />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/imageSuccess" element={<SuccessPage />} />
              <Route path="/shippo" element={<TestShippo />} />
              <Route path="/game" element={<SpinningWheelGame />} />
              <Route path="/services/screen-printing" element={<ScreenPrinting />} />
              <Route path="/services/embroidery" element={<Embroidery />} />
              <Route path="/quote" element={<QuoteForm />} />
              <Route path="/services/laser-etching" element={<LaserEtching />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/admin-orders"
                element={
                  <Protected>
                    <AdminOrders />
                  </Protected>
                }
              />
              <Route
                path="/admin-all-users"
                element={
                  <Protected>
                    <AdminUsers />
                  </Protected>
                }
              />
            </Routes>
            {/* <Footer /> */}
          </BrowserRouter>
        </LoadScript>
      </div>
    </CartProvider>
  );
};

export default App;
